import { Component, OnInit,ElementRef,Input, ViewChild, AfterViewInit, AfterViewChecked, ChangeDetectorRef, Injector, InjectionToken, ComponentFactoryResolver } from '@angular/core';
import { GridSelectorComponent } from '../../system-utils/grid-selector/grid-selector.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { DynamicFormsService } from '../../services/dynamic-forms.service';
import { DatatableComponent, selectRows } from '@swimlane/ngx-datatable';
import { HTTPService } from 'src/app/services/http.service';
import { action } from 'src/app/interfaces/action';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserConfigServices } from 'src/app/services/user-config.services';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { RefreshPreferencesServices } from 'src/app/services/RefreshPreferences.service';
import { Component as cpm, REGISTRY} from 'src/app/interfaces/registry-services'
import { Subscription } from 'rxjs';
import { flowData } from 'src/app/interfaces/flowData';
import { FlowModalComponent } from 'src/app/forms/flow-action/flowaction.component';
import { DialogService } from 'src/app/services/dialog.service';
import { CustomActionParametersComponent } from 'src/app/forms/simple-datagrid/custom-action-parameters/custom-action-parameters.component';

@Component({
    selector: 'app-tool-bar',
    templateUrl: './tool-bar.component.html',
    styleUrls: ['./tool-bar.component.scss'],
    standalone: false
})
export class ToolBarComponent implements OnInit, AfterViewChecked {

  @Input("instanceName") instanceName:string;
  @Input("instanceDescription") instanceDescription:String;
  @Input("instanceId") instanceId:String;
  @Input("dataTable") DataTable:DatatableComponent;
  @ViewChild("input") inputFilter:ElementRef;
  @Input("service") dynaServices:DynamicFormsService;
  @Input("userId") userId:String;
  
  actionList:action[] = [];
  public showAction:boolean = false;
  public stopEditing:Boolean = true;
  public stopAdd:Boolean = false;
  public stopSave:Boolean = true;
  public stopRemove:Boolean = false;
  public filters:String[] = [];

  sub:Subscription;
  sub2:Subscription;
  sub3:Subscription;
  sub4:Subscription;
  sub5:Subscription;
  


  public _dynaServices:DynamicFormsService;

  

  constructor(private cfr: ComponentFactoryResolver,private injector: Injector, private modal:NzModalService, private http:HTTPService, private snackBar:SnackbarService, private ucs:UserConfigServices,private cd:ChangeDetectorRef, private dialogServices:DialogService )  {
    
  }

  ngOnDestroy(){
      if (this.sub!= null){this.sub.unsubscribe();}
      if (this.sub2!= null){this.sub2.unsubscribe();}
      if (this.sub3!= null){this.sub3.unsubscribe();}
      if (this.sub4!= null){this.sub4.unsubscribe();}
      if (this.sub5!= null){this.sub5.unsubscribe();}
      
  }

  ngAfterViewChecked(){
    
    if ( this._dynaServices.userConfig != null ){

      if ( this._dynaServices.userConfig['FILTER'] != null && this._dynaServices.userConfig['FILTER']!= undefined && this._dynaServices.userConfig['FILTER'].length>0){
        
        try{
          this.filters = JSON.parse(this._dynaServices.userConfig['FILTER'].toString());
        }catch(e){
          this.filters =this._dynaServices.userConfig['FILTER'];
        }
       }
    }
  }

  ngOnInit() {
    
    this._dynaServices = this.dynaServices;

    this.sub = this.ucs.loadActions(this.instanceName).subscribe(responseAction=>{
      this.actionList = responseAction['Mktpdicaction'];
      if ( this.actionList.length > 0 ){
        this.showAction = !this.showAction;
        this.cd.markForCheck();
      }
    })
  }

  saveFilter(value:String ){

    let arrayFilter:String[]  = [];

    if ( this._dynaServices.userConfig["FILTER"] != null ){
      
      try{
        arrayFilter = JSON.parse(this._dynaServices.userConfig['FILTER']);
      }catch ( e ){
        arrayFilter = this._dynaServices.userConfig['FILTER'];
      }
      
      if ( arrayFilter.indexOf(value.trim()) == -1){
        arrayFilter.push(value.trim());
      }
      this._dynaServices.userConfig["FILTER"] = arrayFilter;
    }else{  
      if ( arrayFilter.indexOf(value.trim()) == -1){
        arrayFilter.push(value.trim());
      }
      this._dynaServices.userConfig["FILTER"] = arrayFilter;
    }


    this._dynaServices.userConfig["FILTER"] = JSON.stringify(this._dynaServices.userConfig["FILTER"]);

    let jsonDec:Object ={
      "entityName":"Mktpdic",
      "condition":`instancename='${this.instanceName}'`
    };

    this.filters = arrayFilter;

    this.sub2 = this.http.post(jsonDec,"JsonBrokerServices/find",false).subscribe(
      data =>{
        let idInstance:number = data["Mktpdic"][0]["IDINSTANCE"];
        let jsonSave:Object = {
          "entityName":"Mktpusercfg",
          "IDUSER": this.userId,
          "IDINSTANCE":idInstance,
          "FILTER": this._dynaServices.userConfig["FILTER"] 
          }

          this.sub3 = this.http.post(jsonSave,"JsonBrokerServices/save",true).subscribe();
        }
    );

  }


  openFieldsSelect():void{
    const dialogRef = this.modal.create({
      nzContent: GridSelectorComponent,
      nzWidth: '800px',
      nzFooter: null,
      nzClosable: false,
      nzData: {availableColumns :this._dynaServices.availableColumns , enableColumns :this._dynaServices.enabledColumns, dynaServices:this._dynaServices}
    });

    this.sub4 = dialogRef.afterClose.subscribe(
      result => {
      if ( result != null ){
        this._dynaServices.enabledColumns = result[0];
        this._dynaServices.availableColumns = result[1];
        var col:Object = {};

        let jsonOb:JSON = null;
        try{
            jsonOb = JSON.parse(this._dynaServices.userConfig['CONFIG']);
        }catch ( e ){
            jsonOb = this._dynaServices.userConfig['CONFIG'];
        }


        let config:Array<Object> = jsonOb['datagrid']['enableColumns'];

        config.forEach(x=>{
            let indexIn:number = 0;
            if ( this._dynaServices.enabledColumns.find((value:columnsDef,index:number,obj:columnsDef[])=>{
                
                if ( x["columnName"] == value.COLUMNNAME){
                  indexIn = index;
                  return true;
                }else{
                  return false;
                }
            }) != null) {
                x["visible"] = true;
                x["columnGridOrder"] = indexIn + 1;
            } else{
              x["visible"] = false;
            };
        });

        this._dynaServices.userConfig['CONFIG'] = JSON.stringify({ 'datagrid': {'enableColumns':config}});

        let jsonDec:Object ={
          "entityName":"Mktpdic",
          "condition":`instancename='${this.instanceName}'`
        };
    
        this.dynaServices.saveUserCfg(jsonDec);


        this._dynaServices.doRefreshColumns();

      }
      
    },error => {
        throw error;
    } ,()=>{
    }
    
    );
    
  }

  addRow(){
    this._dynaServices.startAddRow(false);
    this.stopAdd = true;
    this.stopRemove = true;
  }

  
  updateFilter(event:KeyboardEvent){
    if ( event.keyCode == 13 ){
        if (this.inputFilter.nativeElement.value != null && this.inputFilter.nativeElement.value != ""  ){
            this.saveFilter(this.inputFilter.nativeElement.value);
            this.dynaServices.fetch(0,false,false);
            
        }
    }
  }

  cancelEditing(){

    if ( this._dynaServices.addingNewRow){
      this._dynaServices.addingNewRow = false;
      //this._dynaServices.gridMode = true;
      this._dynaServices.dynamicForm.markAsPristine();
      this._dynaServices.dynamicForm.markAsUntouched();
      //this._dynaServices.refreshForm(null,null,true);
      this._dynaServices.editingRow = false;
      this._dynaServices.enableSave = false;
      this._dynaServices.changeFace();
      this.stopRemove = false;
      this.stopAdd = false;
    }else{
      this._dynaServices.addingNewRow = false;
      //this._dynaServices.gridMode = true;
      this._dynaServices.dynamicForm.markAsPristine();
      this._dynaServices.dynamicForm.markAsUntouched();
      this._dynaServices.refreshForm(null,null,true);
      this._dynaServices.editingRow = false;
      this._dynaServices.enableSave = false;
      this.stopRemove = false;
      this.stopAdd = false;
    }

    
  }

  expandFields(){
    this._dynaServices.expandFields(this.DataTable);
  }


  saveRow(){
    //this._dynaServices.gridMode = true;
    this._dynaServices.saveRow();
    this.stopRemove = false;
    this.stopAdd = false;
    this.stopSave = true;
  }

  duplicate(){
    this._dynaServices.startAddRow(true);
    this.stopAdd = true;
    this.stopRemove = true;
  }


  callCustomAction(action:action, event:Event){
    
    
    //const service = this.injector.get<any>(new InjectionToken<any>(serviceName));



    
    //service.refresh(this._dynaServices.selectedRow);

    if ( this._dynaServices.selectedRow.length > 0 ){
      
      if ( action.TYPE === "P" || action.TYPE==="J" || action.TYPE==="F"){
        this.sub5 = this.http.executeBackEndAction(this.instanceName, action, this._dynaServices.selectedRow,null ).subscribe(sucesso=>{
           let mensagens:string[] = sucesso['mensagens'];
           
           let mensagemFinal:string = "";
           if ( ObjectUtil.isNotEmpty(mensagens)){
              mensagens.forEach(mensagem=>{
                mensagemFinal = mensagemFinal + mensagem + "\n\r"
             })

             this.snackBar.showSuccess(mensagemFinal);
           }else{
            this.snackBar.showSuccess("Ação executada com sucesso.");
           }

           this._dynaServices.selectedRow = [];
           
           const promises = [];
           this._dynaServices.selectedRow.forEach(selected=>{
            promises.push(
                new Promise((resolve,reject)=>{
                  let ob:Object = {};  
                  this._dynaServices.displayedColumns.filter(x=>{return x.ISPK === 1}).forEach(y=>{
                        ob[y.COLUMNNAME] = selected[y.COLUMNNAME];    
                  });
            
                  this._dynaServices.refreshLocalData(ob);
                  resolve("salvando")
                })
              )
                
            });

            Promise.all(promises);
           
          

        },error=>{
          throw error;
        });

        

      }else if(action.TYPE == "C"){

        if (action.PARAMETERS != null && action.PARAMETERS.length > 0) {
          this.dialogServices.openGenericDialog(
            CustomActionParametersComponent,
            action.PARAMETERS,
            (data) => {
              //this.executeCustomAction(action, data);
              openFlowData(data, this);
            }
         );
        }else{
          openFlowData(null, this);

        }        
      }else{

        let serviceName = action.EXPRESSION.split('.')[0];
        let methodName = action.EXPRESSION.split('.')[1];
        const component = REGISTRY.get(serviceName);
        const service = this.injector.get<any>(component);
        service[methodName](this._dynaServices.selectedRow);
       
      }
    }

    function openFlowData(parameters, self) {
      let flowData: flowData = {
        selected: self._dynaServices.selectedRow,
        action: action,
        function: null,
        parameters: parameters
      };



      self.dialogServices.openGenericDialog(
        FlowModalComponent,
        flowData,
        (data) => {
        }
      );
    }
  }

}
